<template>
  <div id="mainBox">
    <div class="historyTag">
      <historyTag :historyArr="historyArr"></historyTag>
    </div>

    <div class="flex search-box">
      <div class="search-item">
        <span style="white-space: nowrap; margin-right: 8px">鉴别号：</span>
        <div style="width: 180px">
          <el-input v-model="query.inspectionNo" placeholder="请输入鉴别号" clearable @keyup.enter.native="searchFn" />
        </div>
      </div>

      <div class="search-item">
        <span style="white-space: nowrap; margin-right: 8px">订单号：</span>
        <div style="width: 180px">
          <el-input v-model="query.orderNo" placeholder="请输入订单编号" clearable @keyup.enter.native="searchFn" />
        </div>
      </div>

      <div class="search-item">
        <span style="white-space: nowrap; margin-right: 8px">闲鱼订单号：</span>
        <div style="width: 180px">
          <el-input
            v-model="query.goofishOrderNo"
            placeholder="请输入闲鱼订单号"
            clearable
            @keyup.enter.native="searchFn"
          />
        </div>
      </div>

      <div class="search-item">
        <span style="white-space: nowrap; margin-right: 8px">成交渠道：</span>
        <div style="width: 140px">
          <el-select v-model="query.saleChannel" placeholder="全部" clearable style="width: 100%">
            <el-option label="自研" value="MINI_PROGRAM" />
            <el-option label="闲鱼" value="GOOFISH" />
            <el-option label="闲鱼拍卖" value="GOOFISH_AUCTION" />
          </el-select>
        </div>
      </div>

      <div class="search-item">
        <span style="white-space: nowrap; margin-right: 8px">订单类型：</span>
        <div style="width: 140px">
          <el-select v-model="query.orderType" placeholder="全部" clearable style="width: 100%">
            <el-option label="寄售订单" :value="1" />
            <el-option label="鉴别订单" :value="2" />
            <el-option label="普通闲置订单" :value="3" />
            <el-option label="安心购订单" :value="4" />
          </el-select>
        </div>
      </div>

      <div class="search-item">
        <span style="white-space: nowrap; margin-right: 8px">进入待发货：</span>
        <div style="width: 380px">
          <el-date-picker
            v-model="query.timeRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="上次发货后"
            end-placeholder="当前"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            :disabled="delayShipTab === 'DELAYED'"
          />
        </div>
      </div>
    </div>

    <div class="operate-btns">
      <el-button type="success" size="medium" @click="searchFn">搜索</el-button>
      <el-button size="medium" @click="resetFn">重置</el-button>
      <el-button type="primary" size="medium" @click="copyAllAddresses">复制所有地址</el-button>
      <el-button type="warning" size="medium" :loading="exportLoading" @click="exportAddresses">导出表格</el-button>
    </div>

    <el-tabs v-model="delayShipTab" @tab-click="onDelayShipTabChange" class="delay-ship-tabs">
      <el-tab-pane label="正常待发货" name="NORMAL" />
      <el-tab-pane label="延迟发货" name="DELAYED" />
      <el-tab-pane label="全部" name="ALL" />
    </el-tabs>
    <div v-if="delayShipTab === 'DELAYED'" class="delay-ship-hint">
      延迟列表不按「进入待发货」时间过滤，展示全部挂起单
    </div>

    <div class="table-scroll-wrap">
    <el-table class="data-table" :data="tableData" border style="width: 100%; margin-top: 12px" v-loading="loading"
      @selection-change="handleSelectionChange">
      <el-table-column prop="inspectionNo" width="150" align="center" label="鉴别号" />
      <el-table-column prop="shelfNo" width="120" align="center" label="货架号">
        <template slot-scope="scope">
          <span v-if="scope.row.shelfNo">{{ scope.row.shelfNo }}</span>
          <span v-else style="color: #999">未绑定</span>
        </template>
      </el-table-column>
      <el-table-column prop="orderNo" width="150" align="center" label="订单编号" />
      <el-table-column prop="orderType" width="150" align="center" label="订单类型">
        <template slot-scope="scope">
          <div>{{ getOrderTypeText(scope.row.orderType) }}</div>
          <el-tag v-if="isOrphanOfficialConsign(scope.row)" type="info" size="mini" style="margin-top: 4px">
            官方寄售导入
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="成交渠道" width="180" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <template v-if="scope.row.saleChannelLabel && scope.row.saleChannelLabel !== '—'">
            <el-tag
              :type="isGoofishSaleChannel(scope.row) ? 'warning' : 'success'"
              size="mini"
            >
              {{ channelLabel(scope.row) }}
            </el-tag>
            <div
              v-if="isGoofishSaleChannel(scope.row) && scope.row.goofishOrderNo"
              style="margin-top: 4px; color: #666; font-size: 12px; line-height: 1.3"
            >
              {{ scope.row.goofishOrderNo }}
            </div>
          </template>
          <span v-else style="color: #999">—</span>
        </template>
      </el-table-column>
      <el-table-column label="商品信息" min-width="220" align="center" class-name="cell-title-wrap">
        <template slot-scope="scope">
          <div style="line-height: 1.6; text-align: left">
            <div v-if="scope.row.productTitle">{{ scope.row.productTitle }}</div>
            <div v-if="brandDisplay(scope.row)">品牌：{{ brandDisplay(scope.row) }}</div>
            <div v-if="typeDisplay(scope.row)">型号：{{ typeDisplay(scope.row) }}</div>
            <div v-if="scope.row.batchNum">批次号：{{ scope.row.batchNum }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="鉴别结果" width="80" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.result" :style="{ color: getDictColor('resultOptions', scope.row.result) }">
            {{ getDictLabel('resultOptions', scope.row.result) }}
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="发货状态" width="100" align="center">
        <template slot-scope="scope">
          <el-tag v-if="isDelayShipRow(scope.row)" type="warning" size="mini">延迟发货</el-tag>
          <span v-else style="color: #67C23A">待发货</span>
        </template>
      </el-table-column>
      <el-table-column label="期望发货日" width="160" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.delayShipUntil">{{ formatTime(scope.row.delayShipUntil) }}</span>
          <span v-else style="color: #999">—</span>
        </template>
      </el-table-column>
      <el-table-column label="延迟备注" min-width="160" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.delayShipRemark">{{ scope.row.delayShipRemark }}</span>
          <span v-else style="color: #999">—</span>
        </template>
      </el-table-column>
      <el-table-column prop="receiverName" width="120" align="center" label="收货人" />
      <el-table-column prop="receiverPhone" width="130" align="center" label="联系电话" />
      <el-table-column prop="receiverAddress" min-width="200" align="center" label="收货地址">
        <template slot-scope="scope">{{ formatReceiverAddress(scope.row) }}</template>
      </el-table-column>
      <el-table-column prop="createTime" width="160" align="center" label="创建时间">
        <template slot-scope="scope">{{ formatTime(scope.row.createTime) }}</template>
      </el-table-column>
      <el-table-column min-width="300" align="left" label="操作" fixed="right">
        <template slot-scope="scope">
          <div style="display: flex; flex-wrap: wrap; gap: 6px; justify-content: flex-start;">
            <el-button type="primary" size="small" @click="showDetailDialog(scope.row)">详情</el-button>
            <el-button type="success" size="small" @click="confirmDelivery(scope.row)">确认发货</el-button>
            <el-button
              v-if="canModifyOrphanLogistics(scope.row)"
              type="warning"
              size="small"
              plain
              @click="openModifyLogistics(scope.row)"
            >修改单号</el-button>
            <el-button
              v-if="!isDelayShipRow(scope.row)"
              type="warning"
              size="small"
              @click="openDelayShip(scope.row)"
            >延迟发货</el-button>
            <el-button
              v-else
              type="warning"
              plain
              size="small"
              @click="cancelDelayShip(scope.row)"
            >取消延迟</el-button>
            <el-button
              v-if="canRetryGoofishShip(scope.row)"
              class="btn-goofish"
              size="small"
              :loading="goofishShipRetryLoadingId === (scope.row.relatedTradeOrderId || scope.row.orderId)"
              @click="retryGoofishShip(scope.row)"
            >重新推送</el-button>
            <el-button type="info" size="small" @click="copyAddress(scope.row)">复制地址</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    </div>

    <!-- 详情弹窗 -->
    <el-dialog title="鉴别作业详情" :visible.sync="detailDialogVisible" width="1000px" :close-on-click-modal="false"
      @closed="onDetailDialogClosed" style="max-height: 95vh; overflow: hidden;">
      <div style="height: calc(95vh - 220px); overflow-y: auto;">
        <InspectionJobDetail v-if="detailJobId" :job-id="detailJobId" />
      </div>
    </el-dialog>

    <el-dialog title="成交单详情" :visible.sync="orphanDetailVisible" width="720px" :close-on-click-modal="false">
      <el-descriptions v-if="orphanDetail" :column="2" border size="small">
        <el-descriptions-item label="订单号" :span="2">{{ orphanDetail.orderNo || "-" }}</el-descriptions-item>
        <el-descriptions-item label="商品编号">{{ orphanDetail.productNo || "-" }}</el-descriptions-item>
        <el-descriptions-item label="货架号">{{ orphanDetail.shelfNo || "未绑定" }}</el-descriptions-item>
        <el-descriptions-item label="鉴别号">{{ orphanDetail.inspectionNo || "-" }}</el-descriptions-item>
        <el-descriptions-item label="商品" :span="2">{{ orphanDetail.productTitle || "-" }}</el-descriptions-item>
        <el-descriptions-item label="品牌">{{ brandDisplay(orphanDetail) || "-" }}</el-descriptions-item>
        <el-descriptions-item label="型号">{{ typeDisplay(orphanDetail) || "-" }}</el-descriptions-item>
        <el-descriptions-item label="评级">{{ orphanDetail.gradeLevel || "-" }}</el-descriptions-item>
        <el-descriptions-item label="成交渠道">{{ channelLabel(orphanDetail) }}</el-descriptions-item>
        <el-descriptions-item label="闲鱼单号" :span="2">{{ orphanDetail.goofishOrderNo || "-" }}</el-descriptions-item>
        <el-descriptions-item label="收货人">{{ orphanDetail.receiverName || "-" }}</el-descriptions-item>
        <el-descriptions-item label="电话">{{ orphanDetail.receiverPhone || "-" }}</el-descriptions-item>
        <el-descriptions-item label="收货地址" :span="2">{{ formatReceiverAddress(orphanDetail) }}</el-descriptions-item>
        <el-descriptions-item label="进入待发货">{{ formatTime(orphanDetail.platformPendingEnterTime || orphanDetail.createTime) }}</el-descriptions-item>
        <el-descriptions-item label="延迟发货">
          <span v-if="isDelayShipRow(orphanDetail)">{{ formatTime(orphanDetail.delayShipUntil) }} {{ orphanDetail.delayShipRemark || "" }}</span>
          <span v-else>否</span>
        </el-descriptions-item>
        <el-descriptions-item label="寄出物流" :span="2">
          <template v-if="orphanDetail.tradeLogisticsNo || orphanDetail.logisticsNo">
            {{ companyTitle(orphanDetail.logisticsCompany) }} {{ orphanDetail.tradeLogisticsNo || orphanDetail.logisticsNo }}
          </template>
          <span v-else style="color: #999">未发货</span>
          <el-button type="text" size="mini" @click="openModifyLogistics(orphanDetail)">修改单号</el-button>
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>

    <!-- 延迟发货弹窗 -->
    <el-dialog title="延迟发货" :visible.sync="delayShipVisible" width="480px" :close-on-click-modal="false">
      <el-form label-width="100px">
        <el-form-item :label="delayShipForm.inspectionNo ? '鉴别号' : '订单号'">
          <div>{{ delayShipForm.inspectionNo || delayShipForm.orderNo }}</div>
        </el-form-item>
        <el-form-item label="期望发货日" required>
          <el-date-picker
            v-model="delayShipForm.delayShipUntil"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="备注" required>
          <el-input
            v-model="delayShipForm.delayShipRemark"
            type="textarea"
            :rows="3"
            maxlength="200"
            show-word-limit
            placeholder="如：客户要求下周发货"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delayShipVisible = false">取消</el-button>
        <el-button type="warning" :loading="delayShipLoading" @click="submitDelayShip">确定</el-button>
      </span>
    </el-dialog>

    <!-- 确认发货弹窗 -->
    <el-dialog :title="shipIsModify ? '修改寄出单号' : '确认发货'" :visible.sync="shipToBuyerVisible" width="520px" :close-on-click-modal="false">
      <el-form label-width="90px">
        <el-form-item :label="shipToBuyerForm.inspectionNo ? '鉴别号' : '订单号'">
          <div>{{ shipToBuyerForm.inspectionNo || shipToBuyerForm.orderNo }}</div>
        </el-form-item>
        <el-form-item label="收货人">
          <div>{{ shipToBuyerForm.receiverName }}</div>
        </el-form-item>
        <el-form-item label="联系电话">
          <div>{{ shipToBuyerForm.receiverPhone }}</div>
        </el-form-item>
        <el-form-item label="收货地址">
          <div>{{ formatReceiverAddress(shipToBuyerForm) }}</div>
        </el-form-item>
        <el-form-item label="物流公司" required>
          <el-select v-model="shipToBuyerForm.expressCompany" placeholder="请选择物流公司" filterable style="width: 100%">
            <el-option v-for="item in companyData" :key="item.code" :label="item.title" :value="item.code" />
          </el-select>
        </el-form-item>
        <el-form-item label="物流单号" required>
          <el-input v-model="shipToBuyerForm.expressNo" placeholder="请填写物流单号" maxlength="60" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="shipToBuyerVisible = false">取消</el-button>
        <el-button type="success" :loading="shipToBuyerLoading" @click="submitShipToBuyer">
          {{ shipIsModify ? "确认修改" : "确认发货" }}
        </el-button>
      </span>
    </el-dialog>

    <list-pagination
      :total="tableTotal"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      @page-change="changePage"
      @size-change="handlePageSizeChange"
    />
  </div>
</template>

<script>
import historyTag from "@/components/historyTag";
import InspectionJobDetail from "./detail.vue";
import expressInfo from "@/util/expressInfo";
import { api } from "@/util/requestUrl";
import {
  buildSinceLastDeliveryTimeRange,
  resolveCreateTimeRange,
} from "@/util/inspectionJobTimeRange";
import { formatAddressText } from "@/util/inspectionJobDisplay";

export default {
  components: {
    historyTag,
    InspectionJobDetail,
  },
  data() {
    return {
      historyArr: ["鉴别作业", "待发货列表"],
      tableData: [],
      currentPage: 1,
      pageSize: 50,
      tableTotal: 0,
      selectedRows: [],
      loading: false,
      exportLoading: false,
      lastDeliveryTime: null,
      goofishShipRetryLoadingId: null,

      dicts: {
        resultOptions: [
          { value: 1, label: "通过", color: "#67C23A" },
          { value: 2, label: "不通过", color: "#F56C6C" },
        ],
      },

      detailDialogVisible: false,
      detailJobId: null,
      orphanDetailVisible: false,
      orphanDetail: null,

      shipToBuyerVisible: false,
      shipToBuyerLoading: false,
      shipIsModify: false,
      companyData: expressInfo.arr || [],
      shipToBuyerForm: {
        id: null,
        orderId: null,
        orderNo: "",
        inspectionNo: "",
        orderType: null,
        pendingDeliveryScene: "",
        relatedTradeOrderId: null,
        receiverName: "",
        receiverPhone: "",
        receiverAddress: "",
        expressCompany: "",
        expressNo: "",
      },

      delayShipTab: "NORMAL",
      delayShipVisible: false,
      delayShipLoading: false,
      delayShipForm: {
        id: null,
        relatedTradeOrderId: null,
        inspectionNo: "",
        orderNo: "",
        delayShipUntil: "",
        delayShipRemark: "",
      },

      query: {
        timeRange: null,
        inspectionNo: "",
        orderNo: "",
        goofishOrderNo: "",
        saleChannel: "",
        orderType: null,
      },
    };
  },
  mounted() {
    this.initDefaultTimeRange().finally(() => {
      this.getList();
    });
  },
  methods: {
    delayShipFlagParam() {
      if (this.delayShipTab === "NORMAL") return 0;
      if (this.delayShipTab === "DELAYED") return 1;
      return null;
    },

    isDelayShipRow(row) {
      if (!row) return false;
      const flag = row.delayShipFlag;
      return flag === 1 || flag === "1" || flag === true;
    },

    isOrphanOfficialConsign(row) {
      if (!row) return false;
      if (row.orphanOfficialConsign === true || row.orphanOfficialConsign === 1 || row.orphanOfficialConsign === "1") {
        return true;
      }
      return !row.id && row.pendingDeliveryScene === "consignment_sold";
    },

    initDefaultTimeRange() {
      return this.$axios
        .get(api.lastPlatformDeliveryTime)
        .then((res) => {
          if (res.data && res.data.code === 200) {
            this.lastDeliveryTime = res.data.data || null;
          }
          this.query.timeRange = buildSinceLastDeliveryTimeRange(this.lastDeliveryTime);
        })
        .catch(() => {
          this.query.timeRange = null;
        });
    },

    buildQueryParams(withPage) {
      const params = {
        inspectionNo: this.query.inspectionNo || null,
        orderNo: this.query.orderNo || null,
        goofishOrderNo: this.query.goofishOrderNo || null,
        saleChannel: this.query.saleChannel || null,
        orderType: this.query.orderType || null,
        delayShipFlag: this.delayShipFlagParam(),
      };
      if (withPage) {
        params.page = this.currentPage;
        params.size = this.pageSize;
      }
      // 延迟 Tab：不传进入待发货时间，展示全部挂起单
      if (this.delayShipTab !== "DELAYED") {
        Object.assign(params, resolveCreateTimeRange(this.query.timeRange));
      }
      return params;
    },

    getList() {
      const params = this.buildQueryParams(true);

      this.loading = true;
      this.$axios
        .post(api.selPlatformWaitingDeliveryList, params)
        .then((res) => {
          this.loading = false;
          if (res.data.code === 200) {
            this.tableData = res.data.data.records || [];
            this.tableTotal = res.data.data.total || 0;
          } else {
            this.$message.error(res.data.msg || "获取列表失败");
          }
        })
        .catch(() => {
          this.loading = false;
          this.$message.error("网络异常");
        });
    },

    searchFn() {
      this.currentPage = 1;
      this.getList();
    },

    onDelayShipTabChange(tab) {
      if (tab && tab.name) {
        this.delayShipTab = tab.name;
      }
      this.currentPage = 1;
      this.getList();
    },

    resetFn() {
      this.delayShipTab = "NORMAL";
      this.initDefaultTimeRange().finally(() => {
        this.query.inspectionNo = "";
        this.query.orderNo = "";
        this.query.goofishOrderNo = "";
        this.query.saleChannel = "";
        this.query.orderType = null;
        this.currentPage = 1;
        this.getList();
      });
    },

    openDelayShip(row) {
      this.delayShipForm = {
        id: row.id || null,
        relatedTradeOrderId: row.relatedTradeOrderId || null,
        inspectionNo: row.inspectionNo || "",
        orderNo: row.orderNo || "",
        delayShipUntil: "",
        delayShipRemark: "",
      };
      this.delayShipVisible = true;
    },

    submitDelayShip() {
      const f = this.delayShipForm || {};
      if (!f.delayShipUntil) {
        this.$message.error("请选择期望发货日");
        return;
      }
      if (!(f.delayShipRemark || "").trim()) {
        this.$message.error("请填写备注");
        return;
      }
      this.delayShipLoading = true;
      this.$axios
        .post(api.setInspectionJobDelayShip, {
          id: f.id || null,
          relatedTradeOrderId: f.id ? null : f.relatedTradeOrderId,
          delayShipUntil: f.delayShipUntil,
          delayShipRemark: (f.delayShipRemark || "").trim(),
        })
        .then((res) => {
          this.delayShipLoading = false;
          if (res.data.code === 200) {
            this.$message.success("已设置延迟发货");
            this.delayShipVisible = false;
            this.delayShipTab = "DELAYED";
            this.currentPage = 1;
            this.getList();
          } else {
            this.$message.error(res.data.msg || "设置失败");
          }
        })
        .catch(() => {
          this.delayShipLoading = false;
          this.$message.error("网络异常");
        });
    },

    cancelDelayShip(row) {
      this.$confirm("取消延迟后，该单将回到「正常待发货」？", "提示", { type: "warning" })
        .then(() => {
          return this.$axios.post(api.cancelInspectionJobDelayShip, {
            id: row.id || null,
            relatedTradeOrderId: row.id ? null : row.relatedTradeOrderId,
          });
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success("已取消延迟");
            this.getList();
          } else {
            this.$message.error(res.data.msg || "取消失败");
          }
        })
        .catch(() => {});
    },

    changePage(page) {
      this.currentPage = page;
      this.getList();
    },

    handlePageSizeChange() {
      this.getList();
    },

    handleSelectionChange(rows) {
      this.selectedRows = rows;
    },

    showDetailDialog(row) {
      if (this.isOrphanOfficialConsign(row)) {
        this.orphanDetail = row;
        this.orphanDetailVisible = true;
        return;
      }
      this.detailJobId = row.id;
      this.detailDialogVisible = true;
    },

    onDetailDialogClosed() {
      this.detailJobId = null;
    },

    canModifyOrphanLogistics(row) {
      if (!this.isOrphanOfficialConsign(row)) return false;
      return !!(row.tradeLogisticsNo || row.logisticsNo);
    },

    companyTitle(company) {
      const raw = String(company || "").trim();
      if (!raw) return "";
      const hit = (this.companyData || []).find(
        (item) => item.code === raw || item.code === raw.toLowerCase() || item.title === raw
      );
      return hit ? hit.title : raw;
    },

    mapExpressCompanyToCode(company) {
      const raw = String(company || "").trim();
      if (!raw) return "";
      const lower = raw.toLowerCase();
      const hit = (this.companyData || []).find(
        (item) => item.code === raw || item.code === lower || item.title === raw
      );
      if (hit) return hit.code;
      const fuzzy = (this.companyData || []).find(
        (item) => raw.includes(item.title) || item.title.includes(raw)
      );
      return fuzzy ? fuzzy.code : lower.replace(/\s/g, "");
    },

    openModifyLogistics(row) {
      if (!row) return;
      const no = String(row.tradeLogisticsNo || row.logisticsNo || "").trim();
      const companyRaw = String(row.logisticsCompany || "").trim();
      this.shipIsModify = true;
      this.orphanDetailVisible = false;
      this.shipToBuyerForm = {
        id: row.id,
        orderId: row.orderId,
        orderNo: row.orderNo || "",
        inspectionNo: row.inspectionNo || "",
        orderType: row.orderType,
        pendingDeliveryScene: row.pendingDeliveryScene || "consignment_sold",
        relatedTradeOrderId: row.relatedTradeOrderId || null,
        receiverName: row.receiverName || "",
        receiverPhone: row.receiverPhone || "",
        receiverAddress: row.receiverAddress || "",
        expressCompany: this.mapExpressCompanyToCode(companyRaw),
        expressNo: no,
      };
      this.shipToBuyerVisible = true;
    },

    confirmDelivery(row) {
      this.shipIsModify = false;
      this.shipToBuyerForm = {
        id: row.id,
        orderId: row.orderId,
        orderNo: row.orderNo || "",
        inspectionNo: row.inspectionNo || "",
        orderType: row.orderType,
        pendingDeliveryScene: row.pendingDeliveryScene || "",
        relatedTradeOrderId: row.relatedTradeOrderId || null,
        receiverName: row.receiverName || "",
        receiverPhone: row.receiverPhone || "",
        receiverAddress: row.receiverAddress || "",
        expressCompany: "",
        expressNo: "",
      };
      this.shipToBuyerVisible = true;
    },

    submitShipToBuyer() {
      const f = this.shipToBuyerForm || {};
      const company = (f.expressCompany || "").trim();
      if (!company) {
        this.$message.error("请选择物流公司");
        return;
      }
      const no = (f.expressNo || "").trim();
      if (!no) {
        this.$message.error("请填写物流单号");
        return;
      }
      this.shipToBuyerLoading = true;

      const scene = f.pendingDeliveryScene || "";
      let requestData;
      let requestUrl;

      if (scene === "consignment_sold") {
        if (!f.relatedTradeOrderId) {
          this.shipToBuyerLoading = false;
          this.$message.error("缺少关联成交单，无法发货");
          return;
        }
        requestUrl = api.updateSecondhandOrder;
        requestData = {
          id: f.relatedTradeOrderId,
          logisticsCompany: company,
          logisticsNo: no,
        };
      } else if (scene === "safe_buy_to_buyer") {
        if (!f.orderId) {
          this.shipToBuyerLoading = false;
          this.$message.error("缺少订单ID");
          return;
        }
        requestUrl = api.centerShipToBuyerAfterConfirm;
        requestData = {
          orderId: f.orderId,
          expressCompany: company,
          expressNo: no,
        };
      } else if (scene === "safe_buy_to_seller") {
        if (!f.orderId) {
          this.shipToBuyerLoading = false;
          this.$message.error("缺少订单ID");
          return;
        }
        requestUrl = api.centerShipBackToSeller;
        requestData = {
          orderId: f.orderId,
          expressCompany: company,
          expressNo: no,
        };
      } else if ([1, 2].includes(f.orderType)) {
        if (!f.orderId) {
          this.shipToBuyerLoading = false;
          this.$message.error("缺少订单ID");
          return;
        }
        requestUrl = api.upOrder;
        requestData = {
          id: f.orderId,
          status: 4,
          hxinfo: JSON.stringify({
            code: company,
            phone: f.receiverPhone || "",
            title: company,
            num: no,
          }),
        };
      } else {
        this.shipToBuyerLoading = false;
        this.$message.error("未知发货场景");
        return;
      }

      this.$axios
        .post(requestUrl, requestData)
        .then(async (res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg || "操作失败");
            return;
          }
          this.shipToBuyerVisible = false;
          const doneText = this.shipIsModify ? "寄出单号已更新" : "已确认发货";
          // 闲鱼成交：发货后主动再推一次物流，失败可稍后点「重新推送」
          if (scene === "consignment_sold" && f.relatedTradeOrderId) {
            try {
              const syncRes = await this.$axios.post(api.goofishRetryShipSync, {
                secondhandOrderId: f.relatedTradeOrderId,
              });
              if (syncRes.data && syncRes.data.code === 200 && syncRes.data.data === true) {
                this.$message.success(doneText + "，并已回写闲鱼");
              } else if (syncRes.data && syncRes.data.code === 200) {
                this.$message.warning(doneText + "，但闲鱼回写失败，可到「官方寄售待发货 → 待收货」点重新推送");
              } else {
                this.$message.warning(
                  doneText + "，闲鱼回写失败：" + ((syncRes.data && syncRes.data.msg) || "请稍后重试")
                );
              }
            } catch (e) {
              this.$message.warning(doneText + "，闲鱼回写请求失败，请稍后重新推送");
            }
          } else {
            this.$message.success(doneText);
          }
          this.getList();
        })
        .catch(() => {
          this.$message.error("网络异常");
        })
        .finally(() => {
          this.shipToBuyerLoading = false;
        });
    },

    copyAddress(row) {
      const address = `${row.receiverName || ""} ${row.receiverPhone || ""} ${this.formatReceiverAddress(row)}（${row.shelfNo || "-"}）`;
      this.copyToClipboard(address.trim());
      this.$message.success("地址已复制");
    },

    copyAllAddresses() {
      const params = this.buildQueryParams(false);
      this.$axios
        .post(api.getAllPlatformDeliveryAddresses, params)
        .then((res) => {
          if (res.data.code === 200) {
            const addresses = res.data.data;
            if (addresses) {
              this.copyToClipboard(addresses);
              this.$message.success("所有地址已复制");
            } else {
              this.$message.warning("没有待发货地址");
            }
          } else {
            this.$message.error(res.data.msg || "获取地址失败");
          }
        })
        .catch(() => {
          this.$message.error("网络异常");
        });
    },

    exportAddresses() {
      const params = this.buildQueryParams(false);
      this.exportLoading = true;
      this.$https(api.exportPlatformWaitingDeliveryList, params, "FILE")
        .then((res) => {
          this.exportLoading = false;
          if (!res || !res.data) {
            this.$message.error("导出失败");
            return;
          }
          if (res.data.type && String(res.data.type).indexOf("application/json") !== -1) {
            const reader = new FileReader();
            reader.onload = () => {
              try {
                const json = JSON.parse(reader.result);
                this.$message.error(json.msg || "导出失败");
              } catch (e) {
                this.$message.error("导出失败");
              }
            };
            reader.readAsText(res.data);
            return;
          }
          const blob = new Blob([res.data], {
            type: "application/vnd.ms-excel",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          const now = new Date();
          const pad = (n) => String(n).padStart(2, "0");
          const timeStr = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
          link.download = `寄件地址_${timeStr}.xls`;
          link.click();
          window.URL.revokeObjectURL(url);
          this.$message.success("导出成功");
        })
        .catch((err) => {
          this.exportLoading = false;
          this.$message.error("导出失败：" + (err.message || "网络错误"));
        });
    },

    copyToClipboard(text) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
    },

    formatReceiverAddress(row) {
      const addr = formatAddressText(row && row.receiverAddress);
      return addr || "-";
    },

    getOrderTypeText(type) {
      const types = {
        1: "寄售订单",
        2: "鉴别订单",
        3: "普通闲置订单",
        4: "安心购订单",
      };
      return types[type] || "未知";
    },

    isGoofishSaleChannel(row) {
      if (!row) return false;
      const ch = String(row.saleChannel || "").toUpperCase();
      const label = String(row.saleChannelLabel || "");
      return (
        ch === "GOOFISH" ||
        ch === "GOOFISH_AUCTION" ||
        label === "闲鱼" ||
        label === "闲鱼拍卖" ||
        label.indexOf("闲鱼") === 0
      );
    },

    channelLabel(row) {
      if (!row) return "—";
      const label = String(row.saleChannelLabel || "").trim();
      if (!label || label === "—") return "—";
      if (label === "自研平台" || label === "小程序") return "自研";
      return label;
    },

    resolveGoofishTradeOrderId(row) {
      if (!row) return null;
      if (row.relatedTradeOrderId) return row.relatedTradeOrderId;
      if (this.isGoofishSaleChannel(row) && [3, 4].includes(Number(row.orderType))) {
        return row.orderId || null;
      }
      return null;
    },

    canRetryGoofishShip(row) {
      if (!this.isGoofishSaleChannel(row)) return false;
      const tradeId = this.resolveGoofishTradeOrderId(row);
      if (!tradeId) return false;
      // 待发货页通常尚无物流；有物流且未回写时展示重新推送
      if (!row.tradeLogisticsNo) return false;
      return Number(row.goofishShipSynced) !== 1;
    },

    retryGoofishShip(row) {
      const tradeId = this.resolveGoofishTradeOrderId(row);
      if (!tradeId) {
        this.$message.error("缺少闲鱼成交单");
        return;
      }
      this.goofishShipRetryLoadingId = tradeId;
      this.$axios
        .post(api.goofishRetryShipSync, { secondhandOrderId: tradeId })
        .then((res) => {
          if (res.data && res.data.code === 200 && res.data.data === true) {
            this.$message.success(res.data.msg || "重新推送成功");
            this.getList();
          } else if (res.data && res.data.code === 200) {
            this.$message.error(res.data.msg || "重新推送失败，请查看日志");
          } else {
            this.$message.error((res.data && res.data.msg) || "重新推送失败");
          }
        })
        .catch(() => {
          this.$message.error("网络异常");
        })
        .finally(() => {
          this.goofishShipRetryLoadingId = null;
        });
    },

    brandDisplay(row) {
      if (!row) return "";
      const cn = row.brandName || "";
      const en = row.brandEnglishName || "";
      if (cn && en) return cn + " - " + en;
      return cn || en || "";
    },

    typeDisplay(row) {
      if (!row) return "";
      const cn = row.typeName || "";
      const en = row.typeEnglishName || "";
      if (cn && en) return cn + " - " + en;
      return cn || en || "";
    },

    formatTime(time) {
      if (!time) return "-";
      const date = new Date(time);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    getDictLabel(dictKey, value) {
      if (value == null) return "-";
      var dict = this.dicts[dictKey];
      if (!dict) return "未知";
      var item = null;
      for (var i = 0; i < dict.length; i++) {
        if (dict[i].value === value) {
          item = dict[i];
          break;
        }
      }
      return item ? item.label : "未知";
    },

    getDictColor(dictKey, value) {
      if (value == null) return "#333";
      var dict = this.dicts[dictKey];
      if (!dict) return "#333";
      var item = null;
      for (var i = 0; i < dict.length; i++) {
        if (dict[i].value === value) {
          item = dict[i];
          break;
        }
      }
      return item ? item.color : "#333";
    },
  },
};
</script>

<style scoped>
.historyTag {
  width: 100%;
  box-sizing: border-box;
}

#mainBox {
  width: 100%;
  min-height: 100%;
  min-width: 0;
  overflow-x: hidden;
  padding: 20px;
  padding-bottom: 48px;
  box-sizing: border-box;
}

.search-box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 20px 0;
  row-gap: 8px;
  column-gap: 12px;
}

.search-item {
  display: flex;
  align-items: center;
}

.operate-btns {
  display: flex;
  flex-flow: row wrap;
  margin-bottom: 12px;
  gap: 10px;
}

.delay-ship-tabs {
  margin-bottom: 4px;
}

.delay-ship-hint {
  margin-bottom: 8px;
  font-size: 12px;
  color: #909399;
}

.data-table {
  padding: 0 20px;
}

.btnLi {
  margin: 5px 0;
}

.btn-goofish {
  color: #e6a23c;
  border-color: #f3d19e;
  background: #fdf6ec;
}
</style>



// WEBPACK FOOTER //
// src/pages/inspectionJob/deliveryList.vue